import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import {Field, reduxForm, formPropTypes} from 'redux-form'
import TextInput from '../../forms/TextInput'
import validate from 'mb-app-common/lib/form/validators'


import redirect from '../../../lib/redirect'

export class StaffForm extends PureComponent{
	static propTypes = {
		staffUsername: PropTypes.string,
		changeClientCallback: PropTypes.func.isRequired,
		redirectToStaff: PropTypes.func,
		isLoading: PropTypes.bool,
		...formPropTypes
	}

	static validate(data){
		return validate.fixForReduxForm(validate(data, {
			username: {
				format: {
					pattern: "(?:[0-9]{8}|[0-9]{5})(?:-[12])?",
					message: "^ Valid client number e.g 2001137-1 or 11372"
				}
			}
		}))
	}

	submit(data){
		const username = data.username.split("-")
		if(username.length == 1)	username.push("1")
		if(+username[0] <= 20000000) username[0] = +username[0] + 20000000 + ""

		this.props.changeClientCallback(username.join("-"))
	}

	render(){
		const errorMessage = false
		const {submitting, staffUsername} = this.props

		return (
			<DocumentTitle title="MyBudget - Staff Login">
				<div>
					<If condition={errorMessage}>
						<div className="alert alert-danger" role="alert">
							{errorMessage}
						</div>
					</If>
					<div className="panel panel-primary">
						<header className="panel-heading">
							<h1 className="panel-title">Staff Login</h1>
						</header>
						<section className="panel-body">
							<TextInput
								name="staff"
								label="Staff Account:"
								icon="user"
								value={staffUsername}
								disabled={true}
							/>
							<button
								type="submit"
								className="btn btn-primary"
								onClick={this.props.redirectToStaff}
								disabled={this.props.isLoading}
							>
								{this.props.isLoading ? <span className="glyphicon glyphicon-cog spinner" /> : "Log Into Staff Messaging"}
							</button>

							<hr/>
							<form onSubmit={this.props.handleSubmit(this.submit.bind(this))}>
								<div className="clearfix">
									<Field
										component={TextInput.renderForForm}
										name='username'
										label='Client Number:'
										placeholder="Account Number"
										icon="user"
										tabIndex="1"
										type="text"
										disabled={submitting}
									/>
								</div>
								<button
									tabIndex="-1"
									type="submit"
									className="btn btn-primary"
									disabled={submitting || this.props.isLoading}
								>{submitting || this.props.isLoading ? <span className="glyphicon glyphicon-cog spinner"></span>: 'Log Into The Client Site'}</button>
							</form>
						</section>
					</div>
				</div>
			</DocumentTitle>
		)
	}
}

export default reduxForm({
	form: 'loginStaff',
	destroyOnUnmount: true,
	validate: StaffForm.validate
})(StaffForm)



// WEBPACK FOOTER //
// ./client/components/Login/Staff/Form.js